var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_797",
    "data-name": "Group 797",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_958",
    "data-name": "Rectangle 958",
    width: 40,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M35,0H5A5,5,0,0,0,0,5V25a5,5,0,0,0,5,5H35a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5",
    fill: "#16bcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M9.8,12.587v8.455a1.625,1.625,0,0,0,3.25,0V16.168a8.748,8.748,0,0,1-1.627-1.252A8.625,8.625,0,0,1,9.8,12.587",
    transform: "translate(2.449 3.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M12.074,5.625a7.7,7.7,0,0,0-.052,10.891,7.6,7.6,0,0,0,1.124.938,7.841,7.841,0,0,0,1.8.907c.149.055.3.1.456.142a7.668,7.668,0,0,0,2.153.343,7.749,7.749,0,1,0-5.48-13.222Zm9.986,5.48a4.493,4.493,0,0,1-4.5,4.49h-.006a4.5,4.5,0,1,1,4.5-4.511v.02Z",
    transform: "translate(2.448 0.837)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBest);
export default __webpack_public_path__ + "static/media/best.508edf478d33d6f62948bdbe96283a6e.svg";
export { ForwardRef as ReactComponent };